
import { Component, Prop, Vue } from "vue-property-decorator";

import  ButtonVue from "@/lib/Button.vue";
import { Next, Route } from 'vue-router';

import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();
import { INakladyParams } from "./INakladyParams"

 @Component({   components: { ButtonVue }
})

export default class NakladyVue extends Vue {
    @Prop(Object) par:INakladyParams|undefined;
    @Prop(String) title:string|undefined;
    @Prop(String) field:string|undefined;

    naklad:string="";

    keyod=0;
    key=0;
    lkey=0;
    nkey=0;

    async mounted() {
      this.tidy();
      this.key++
    }

    async chg() {
      this.$emit("naklady_changed")
    }

    async add() {
      if (!this.par) return;
      if (!this.naklad) return
      if (!parseFloat(this.naklad)) return;

      if (parseFloat(<any>this.naklad)<=0) {alert("Wpisz nakład>0"); return;}
      this.par.list.push(parseFloat(this.naklad))
      this.tidy();

      for (let i=0;i<this.par.list.length;i++) {
        if(this.par.list[i] == parseFloat(this.naklad)) {
          this.par.selected=this.par.list[i]
        }

      }
         
      this.lkey++
      this.naklad=""

      await this.chg()
      
    }

    async del() {
      if (!this.par) return;
      if (!this.par.selected) return;
      let idx=-1;
      for (let i=0;i<this.par.list.length;i++) {
        if (this.par.list[i]==this.par.selected) idx=i;
      }
      if (idx>-1) this.par.list.splice(idx,1)
      this.tidy();
      if (this.par.list.length>0) this.par.selected=this.par.list[0]
      this.lkey++
      await this.chg()
    }

    async auto_fill() {
      if (!this.par) return;


      const od=parseFloat(<any>this.par.od)
      const _do=parseFloat(<any>this.par.do)
      const int=parseFloat(<any>this.par.int)
      if (od<=0) { alert("Nieprawidłowa wartość Od"); return; }
      if (_do<=0) { alert("Nieprawidłowa wartość Do"); return; }
      if (int<=0) { alert("Nieprawidłowa wartość Interwał"); return; }
      if ((_do - od)/int>100) { alert("Ilość >100 !"); return; }

      for (let i=od;i<=_do;i+=int) {
        this.par.list.push(i)
      }

      this.tidy();
      this.lkey++
      await this.chg();
    }

    tidy() {
      
      const list_new:number[]= []
      if (!this.par) return;

      const map:any={}


      for (let i=0;i<this.par.list.length;i++) {
        if (parseFloat(<any>this.par.list[i])>0) {
          map[this.par.list[i]]=1
        }
      }
      for( let k in map) {
        list_new.push(<any>k)
      }
      list_new.sort(function(a, b) { return a - b;})
      this.par.list=list_new;
    }
}
    
